import React from 'react';
import Image from './smallerComponent/Image';
import Logo from '../images/logocopy.svg';
import Link from './smallerComponent/Link';

export default function Fourth(){
    return(
        <div className="foot">
            <div className="four">
            <div className="left">
            <Image className="img" src={Logo} alt="logo"/>
            </div>
            <div className="middle">
              <div className="mid">
                  <h1>Features</h1>
                 <div> 
                  <Link value="Link Shortening"/>
                  <Link value="Brand Links"/>
                  <Link value="Analytics"/></div>
              </div>
              <div className="mid">
                  <h1>Resources</h1>
                  <div>
                  <Link value="Blog"/>
                  <Link value="Developer"/>
                  <Link value="Support"/>
                  </div>
              </div>
              <div className="mid">
                  <h1>Company</h1>
                   <div>
                 <Link value="About"/>
                  <Link value="Our Team"/>
                  <Link value="Careers"/>
                  <Link value="Contact"/>
                   </div>
              </div>
            </div>
            <div className="right">
                <i className="fa fa-facebook"></i>
                <i className="fa fa-twitter"></i>
                <i className="fa fa-pinterest"></i>
                <i className="fa fa-instagram"></i>
            </div>
        </div>
            <p>© Copyright Reserved 2022</p>
        </div>
    )
}